import PropTypes from 'prop-types';
import React from 'react';
import Markdown from '../../../components/Markdown';
import {
  TitleWrapper,
  AccordionSectionWrapper,
  UpperContent,
  UpperContentDescription,
  UpperDescription,
  UpperContentImage,
  AccordionList,
  Accordion,
  AccordionHeader,
  AccordionBody,
  AccordionUpper,
  AccordionDescription,
  AccordionImage,
  AccordionBottom,
} from './AccordionSection.style';

const AccordionSection = ({ data }) => (
  <AccordionSectionWrapper>
    <TitleWrapper>{data.title}</TitleWrapper>
    <UpperContent>
      <UpperContentDescription><Markdown src={data.description} Component={UpperDescription} /></UpperContentDescription>
      <UpperContentImage><img src={data.image.file.url} alt={data.image.title} /></UpperContentImage>
    </UpperContent>
    <AccordionList>
      {data.accordionTopics.map(topics => (
        <Accordion key={topics.entryId}>
          <AccordionHeader>
            {topics.accordionLabel}
          </AccordionHeader>
          <AccordionBody>
            <AccordionUpper>
              <Markdown src={topics.upperDescription} Component={AccordionDescription} />
            </AccordionUpper>
            {(() => {
              if (topics.image) {
                return <AccordionImage><img src={topics.image.file.url} alt={topics.image.title} /></AccordionImage>
              }
            })()}
            {(() => {
              if (topics.bottomDescription) {
                return <AccordionBottom>
                  <Markdown src={topics.bottomDescription} Component={AccordionDescription} />
                </AccordionBottom>
              }
            })()}
          </AccordionBody>
        </Accordion>
      ))}
    </AccordionList>
  </AccordionSectionWrapper>
);

AccordionSection.defaultProps = {
  data: {},
};
AccordionSection.propTypes = {
  data: PropTypes.shape(),
};

export default AccordionSection;



// WEBPACK FOOTER //
// ./src/pages/RangePage/AccordionSection/AccordionSection.js